import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnackbarService } from 'src/app/layout/snackbars/snackbar.service';
import { Role, User } from '../user-settings.model';
import { UserSettingsService } from '../user-settings.service';
import { MatSelect, MatOption } from '@angular/material/select';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogStructureComponent } from '../../../layout/dialog-structure/dialog-structure.component';
import { MatFormField, MatLabel, MatInput, MatError } from '@angular/material/input';

@Component({
    selector: 'app-user-settings-dialog',
    templateUrl: './user-settings-dialog.component.html',
    styleUrls: ['./user-settings-dialog.component.scss'],
    imports: [DialogStructureComponent, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatError, MatSelect, MatOption]
})
export class UserSettingsDialogComponent implements OnInit {
  @ViewChild(MatSelect) rolesSelect: MatSelect;
  data: any;

  constructor(
    private dialogRef: MatDialogRef<UserSettingsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private userService: UserSettingsService,
    private snackbarService: SnackbarService
  ) {
    this.data = data;
  }

  userForm: UntypedFormGroup;
  user: User;

  roles: Role[];

  ngOnInit(): void {
    this.getRoles();
    this.userForm = new UntypedFormGroup({
      username: new UntypedFormControl(null, [Validators.required]),
      email: new UntypedFormControl('', [Validators.required, Validators.email]),
      firstName: new UntypedFormControl('', [Validators.required]),
      lastName: new UntypedFormControl(null, [Validators.required]),
      password: new UntypedFormControl(null, Validators.required),
      roles: new UntypedFormControl([], Validators.required),
    });

    if (this.data) {
      this.user = this.data;
      this.setFormValues(this.data);
    }
  }

  setFormValues(user: User): void {
    this.userForm.patchValue(user);
  }

  close(): void {
    this.dialogRef.close();
  }

  getRoles(): void {
    this.userService.fetchRoles().subscribe(
      (data) => {
        this.roles = data;
      },
      (error) => {
        this.snackbarService.openError(error.status);
      }
    );

  }
    save(): void {
      // when customer existing -> update
      if (this.user) {
        this.user = Object.assign(this.user, this.userForm.value);
      } else {
        this.user = this.userForm.value;
        // add to table
      }
      this.dialogRef.close(this.user);
    }

}
